import { render, staticRenderFns } from "./luckWheelManagement.vue?vue&type=template&id=8092479e&scoped=true"
import script from "./luckWheelManagement.vue?vue&type=script&lang=js"
export * from "./luckWheelManagement.vue?vue&type=script&lang=js"
import style0 from "./luckWheelManagement.vue?vue&type=style&index=0&id=8092479e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8092479e",
  null
  
)

export default component.exports